namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeRecptNoBarcodeFg {
        RecptNoBarcodeFg0 = 0,
        RecptNoBarcodeFg1 = 1,
        RecptNoBarcodeFg2 = 2
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeRecptNoBarcodeFg, 'GeniuzPOS.Administration.PsParaGenTypeRecptNoBarcodeFg', 'Administration.PsParaGenTypeRecptNoBarcodeFg');
}
